
export default function ImportantNoteOTS({ item, commission = '5' }) {
    return (
        <p className="important-note">
            <span>Important Note:</span>Urxprt will charge a
            commission of {commission}% of this {item ? item : 'project'}
        </p>
    )
}
